{
    "AUGaHEoj_xzqAz0rBtIfl": {
        "position": {
            "x": 12,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "AUGaHEoj_xzqAz0rBtIfl"
    },
    "PxJfDDzLcAXKEsPGryl2s": {
        "position": {
            "x": 13,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "PxJfDDzLcAXKEsPGryl2s"
    },
    "pgbTxRKoRzdYpacUnH8uH": {
        "position": {
            "x": 14,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "pgbTxRKoRzdYpacUnH8uH"
    },
    "4phu_YP-1F8ebFCRQ1JoO": {
        "position": {
            "x": 15,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "4phu_YP-1F8ebFCRQ1JoO"
    },
    "lwV3qBuvfYiCaNiOJqjuh": {
        "position": {
            "x": 16,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "lwV3qBuvfYiCaNiOJqjuh"
    },
    "IaGnljI2L0n8SJuLsFf-8": {
        "position": {
            "x": 17,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "IaGnljI2L0n8SJuLsFf-8"
    },
    "7zYikdnEPbmSrYxhkpb9v": {
        "position": {
            "x": 13,
            "y": 5,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "7zYikdnEPbmSrYxhkpb9v"
    },
    "3UwFFgJt2SglcBNuMqtb9": {
        "position": {
            "x": 14,
            "y": 5,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "3UwFFgJt2SglcBNuMqtb9"
    },
    "sDPpT_R4jd-wH0akDMt7R": {
        "position": {
            "x": 15,
            "y": 5,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "sDPpT_R4jd-wH0akDMt7R"
    },
    "FpfoC3N8dFfZxcJz4bUSP": {
        "position": {
            "x": 16,
            "y": 5,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "FpfoC3N8dFfZxcJz4bUSP"
    },
    "4mfQ_5sUTuY2-bp5giwjo": {
        "position": {
            "x": 13,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "4mfQ_5sUTuY2-bp5giwjo"
    },
    "qk7tQjK0jjVt0L2H4-Kq6": {
        "position": {
            "x": 14,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "qk7tQjK0jjVt0L2H4-Kq6"
    },
    "gfcyTIkVdHgs-e0h7-j_D": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "gfcyTIkVdHgs-e0h7-j_D"
    },
    "iW9xe0m8nt4trd3r7m_vc": {
        "position": {
            "x": 12,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "iW9xe0m8nt4trd3r7m_vc"
    },
    "cYfuVuDsJzjUqC-wmqrMO": {
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "cYfuVuDsJzjUqC-wmqrMO"
    },
    "eobBX2V4EiOkvMQQ0knwq": {
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "eobBX2V4EiOkvMQQ0knwq"
    },
    "8INMzGuFMABK-MYct4tYs": {
        "position": {
            "x": 16,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "8INMzGuFMABK-MYct4tYs"
    },
    "8nwT_tuDf_PiN7pVy0Z9X": {
        "position": {
            "x": 17,
            "y": 13,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "8nwT_tuDf_PiN7pVy0Z9X"
    },
    "ttCoNsjOtYO1VF7_cAjEy": {
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "ttCoNsjOtYO1VF7_cAjEy"
    },
    "Wberb-tM5cA4Zi2QMNRme": {
        "position": {
            "x": 13,
            "y": 17,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "Wberb-tM5cA4Zi2QMNRme"
    },
    "751ixa8EB_X5XFigg4-kx": {
        "position": {
            "x": 12,
            "y": 17,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "751ixa8EB_X5XFigg4-kx"
    },
    "prSOnEDzd49BDfzq76vyo": {
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "prSOnEDzd49BDfzq76vyo"
    },
    "Pln-AryJbEUDAiG2mwugc": {
        "position": {
            "x": 13,
            "y": 18,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "Pln-AryJbEUDAiG2mwugc"
    },
    "yyjyDYdMrc_8vDYIaWv35": {
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "yyjyDYdMrc_8vDYIaWv35"
    },
    "YqV9eNLP_7P4y9y0KNYwD": {
        "position": {
            "x": 16,
            "y": 17,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "YqV9eNLP_7P4y9y0KNYwD"
    },
    "MUpSYd6nebh7an1cIzHFP": {
        "position": {
            "x": 17,
            "y": 17,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "MUpSYd6nebh7an1cIzHFP"
    },
    "kwQ2YQ3z0WxDJac8oWVub": {
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "kwQ2YQ3z0WxDJac8oWVub"
    },
    "oiPH3oHEkmnyVlcgNkl8u": {
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "oiPH3oHEkmnyVlcgNkl8u"
    },
    "k6UBRgVCU5reO2a63AFWA": {
        "position": {
            "x": 11,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "k6UBRgVCU5reO2a63AFWA"
    },
    "YIAJ-ldLpkQqvtjTqvYAi": {
        "position": {
            "x": 12,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "YIAJ-ldLpkQqvtjTqvYAi"
    },
    "d-oI4h3Cbu7BIf9x3ViVF": {
        "position": {
            "x": 13,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "d-oI4h3Cbu7BIf9x3ViVF"
    },
    "GEvwqdfrWIaWGz3tNxJdX": {
        "position": {
            "x": 14,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "GEvwqdfrWIaWGz3tNxJdX"
    },
    "TMrBaAspEKTvKdzLGB2jJ": {
        "position": {
            "x": 15,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "TMrBaAspEKTvKdzLGB2jJ"
    },
    "1yEqKsTtPcKGBnDMJVvPN": {
        "position": {
            "x": 16,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "1yEqKsTtPcKGBnDMJVvPN"
    },
    "wiTr5SuVf9RoNvm7BBVci": {
        "position": {
            "x": 17,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "wiTr5SuVf9RoNvm7BBVci"
    },
    "xYZBUcaJuHx9VoNGgxe_T": {
        "position": {
            "x": 18,
            "y": 21,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "xYZBUcaJuHx9VoNGgxe_T"
    },
    "_rrjmIHvpssZI4LBFOI-V": {
        "position": {
            "x": 14,
            "y": 22,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "_rrjmIHvpssZI4LBFOI-V"
    },
    "gBiYHfKL5p7SyQsEboOFs": {
        "position": {
            "x": 15,
            "y": 22,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "gBiYHfKL5p7SyQsEboOFs"
    },
    "DNuKEAd5dtbnfz4salwRT": {
        "position": {
            "x": 12,
            "y": 7,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "DNuKEAd5dtbnfz4salwRT"
    },
    "BvtIv7YuH8D-_qn5hv9GU": {
        "position": {
            "x": 14,
            "y": 8,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "BvtIv7YuH8D-_qn5hv9GU"
    },
    "pV8dL00d6Wuo5OJA_Scw7": {
        "position": {
            "x": 15,
            "y": 8,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "pV8dL00d6Wuo5OJA_Scw7"
    },
    "h8dVVeMG5TiNIbxDEmSRD": {
        "position": {
            "x": 17,
            "y": 7,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "h8dVVeMG5TiNIbxDEmSRD"
    },
    "UicFwyDNNcFxhyxFRWjpp": {
        "position": {
            "x": 9,
            "y": 10,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "UicFwyDNNcFxhyxFRWjpp"
    },
    "g5_bFB4nY9LfaEuWi-1in": {
        "position": {
            "x": 10,
            "y": 12,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "g5_bFB4nY9LfaEuWi-1in"
    },
    "jPLVGjZ5bEVft7M0usxlg": {
        "position": {
            "x": 12,
            "y": 12,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "jPLVGjZ5bEVft7M0usxlg"
    },
    "sczuyEy6_0hU-Nn6Nj5O2": {
        "position": {
            "x": 17,
            "y": 12,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "sczuyEy6_0hU-Nn6Nj5O2"
    },
    "6BQB5CwldyMxPROCKogEY": {
        "position": {
            "x": 20,
            "y": 10,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "6BQB5CwldyMxPROCKogEY"
    },
    "pkT3jbBKDYK3yFQo3lQoZ": {
        "position": {
            "x": 19,
            "y": 12,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "pkT3jbBKDYK3yFQo3lQoZ"
    },
    "5jBu_0kU0ZuI15to0hUnR": {
        "position": {
            "x": 9,
            "y": 13,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "5jBu_0kU0ZuI15to0hUnR"
    },
    "T5QoTW-sivLiPsIxALx3i": {
        "position": {
            "x": 7,
            "y": 14,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "T5QoTW-sivLiPsIxALx3i"
    },
    "Ka5mMBpKbS9HCA5owcgvQ": {
        "position": {
            "x": 8,
            "y": 16,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "Ka5mMBpKbS9HCA5owcgvQ"
    },
    "1pcUsVzKxaJg7I3OOsgk2": {
        "position": {
            "x": 10,
            "y": 16,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "1pcUsVzKxaJg7I3OOsgk2"
    },
    "vgo_9wwegF8wd1-PZ-d1m": {
        "position": {
            "x": 20,
            "y": 13,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "vgo_9wwegF8wd1-PZ-d1m"
    },
    "nDN9zK1deBxbfXq9DxjRG": {
        "position": {
            "x": 22,
            "y": 14,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "nDN9zK1deBxbfXq9DxjRG"
    },
    "YQ_C-bElFE8RtaWeXSH1g": {
        "position": {
            "x": 21,
            "y": 16,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "YQ_C-bElFE8RtaWeXSH1g"
    },
    "F0crVZxGs57zQRwzwRAYi": {
        "position": {
            "x": 19,
            "y": 16,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "F0crVZxGs57zQRwzwRAYi"
    },
    "s4rFXrTW76yNTPhw0_UG_": {
        "position": {
            "x": 9,
            "y": 19,
            "z": 1
        },
        "randomJobKey": "swordknight,spearknight,hammerknight",
        "templateKey": "randoms/armored",
        "affiliation": "bad",
        "key": "s4rFXrTW76yNTPhw0_UG_",
        "maxhealth": "40"
    },
    "a8YSMl0lZMDjKOHSAfUng": {
        "position": {
            "x": 20,
            "y": 19,
            "z": 1
        },
        "randomJobKey": "swordknight,spearknight,hammerknight",
        "templateKey": "randoms/armored",
        "affiliation": "bad",
        "key": "a8YSMl0lZMDjKOHSAfUng",
        "maxhealth": "40"
    },
    "mSsvrCt8xAHs9VMKY-HYq": {
        "position": {
            "x": 13,
            "y": 11,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "templateKey": "randoms/melee",
        "affiliation": "none",
        "key": "mSsvrCt8xAHs9VMKY-HYq",
        "maxhealth": "30"
    },
    "N4VN2kmE2sgjgNlnik-oF": {
        "position": {
            "x": 16,
            "y": 11,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "templateKey": "randoms/melee",
        "affiliation": "none",
        "key": "N4VN2kmE2sgjgNlnik-oF",
        "maxhealth": "30"
    },
    "LM_xVTIugKKSIbFt7pcCR": {
        "position": {
            "x": 13,
            "y": 16,
            "z": 1
        },
        "randomJobKey": "dagger,bow,gun",
        "templateKey": "randoms/ranged",
        "affiliation": "none",
        "key": "LM_xVTIugKKSIbFt7pcCR",
        "maxhealth": "30"
    },
    "TbXIl6w7ih7jjN-yoL1il": {
        "position": {
            "x": 16,
            "y": 16,
            "z": 1
        },
        "randomJobKey": "dagger,bow,gun",
        "templateKey": "randoms/ranged",
        "affiliation": "none",
        "key": "TbXIl6w7ih7jjN-yoL1il",
        "maxhealth": "30"
    },
    "8Qw21l3tfCXjDqypZ0_Yp": {
        "position": {
            "x": 13,
            "y": 20,
            "z": 1
        },
        "randomJobKey": "swordcavalier,spearcavalier,hammercavalier",
        "templateKey": "randoms/mounted",
        "affiliation": "none",
        "key": "8Qw21l3tfCXjDqypZ0_Yp",
        "maxhealth": "30"
    },
    "nII3UBtf7h8_FbczBMY7f": {
        "position": {
            "x": 16,
            "y": 20,
            "z": 1
        },
        "randomJobKey": "swordcavalier,spearcavalier,hammercavalier",
        "templateKey": "randoms/mounted",
        "affiliation": "none",
        "key": "nII3UBtf7h8_FbczBMY7f",
        "maxhealth": "30"
    },
    "IZn-4FnIe7PUyQCTilvdq": {
        "position": {
            "x": 11,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "IZn-4FnIe7PUyQCTilvdq"
    },
    "0KVp1SeyVSzw7IWyXA1VA": {
        "position": {
            "x": 18,
            "y": 9,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "0KVp1SeyVSzw7IWyXA1VA"
    },
    "IvYBJipPxSnEgtlPFq7ey": {
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "IvYBJipPxSnEgtlPFq7ey"
    },
    "FdjHvvRWAiMG1UNj6CirR": {
        "position": {
            "x": 16,
            "y": 14,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "FdjHvvRWAiMG1UNj6CirR"
    },
    "G4CwaOY-nXyAYplJOu6NI": {
        "position": {
            "x": 12,
            "y": 18,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "G4CwaOY-nXyAYplJOu6NI"
    },
    "PevBCNwkqTa-nGxAU3ais": {
        "position": {
            "x": 17,
            "y": 18,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "PevBCNwkqTa-nGxAU3ais"
    },
    "xLqVHRCrr9W5xChF1ZopK": {
        "position": {
            "x": 13,
            "y": 22,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "xLqVHRCrr9W5xChF1ZopK"
    },
    "6p0MnSxBEBdtvhs-cpVze": {
        "position": {
            "x": 16,
            "y": 22,
            "z": 1
        },
        "type": "spot",
        "affiliation": "none",
        "templateKey": "spawnspot",
        "key": "6p0MnSxBEBdtvhs-cpVze"
    },
    "ijLmmX_QE5_n6NDt-bQhL": {
        "position": {
            "x": 8,
            "y": 17,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "ijLmmX_QE5_n6NDt-bQhL"
    },
    "WTz96NrphJEEW0id5SeWO": {
        "position": {
            "x": 11,
            "y": 20,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "WTz96NrphJEEW0id5SeWO"
    },
    "Gx4_Fblg_aAxgsYZMiFjd": {
        "position": {
            "x": 18,
            "y": 20,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "Gx4_Fblg_aAxgsYZMiFjd"
    },
    "ad96JUzuYkjAJckAOLbnP": {
        "position": {
            "x": 21,
            "y": 17,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "ad96JUzuYkjAJckAOLbnP"
    },
    "L-7fXjioI6QLOCGKXQcDH": {
        "position": {
            "x": 11,
            "y": 23,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "L-7fXjioI6QLOCGKXQcDH"
    },
    "mL5aTaUpSDcyUlksVUB8S": {
        "position": {
            "x": 13,
            "y": 24,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "mL5aTaUpSDcyUlksVUB8S"
    },
    "cvwh-CbB-sbPLMUU19kD7": {
        "position": {
            "x": 12,
            "y": 24,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "cvwh-CbB-sbPLMUU19kD7"
    },
    "wqXLdnVaTMug7w3SpveNq": {
        "position": {
            "x": 14,
            "y": 24,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "wqXLdnVaTMug7w3SpveNq"
    },
    "4vZkaR0ymtsbqfbEBricC": {
        "position": {
            "x": 15,
            "y": 24,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "4vZkaR0ymtsbqfbEBricC"
    },
    "Z-wdifLSUpYLXev31Uq0v": {
        "position": {
            "x": 16,
            "y": 24,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "Z-wdifLSUpYLXev31Uq0v"
    },
    "rWI8yc2B-ks1b5Uk_l4sK": {
        "position": {
            "x": 17,
            "y": 24,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "rWI8yc2B-ks1b5Uk_l4sK"
    },
    "wGt9QheGnNj17e0M4l1iu": {
        "position": {
            "x": 18,
            "y": 23,
            "z": 1
        },
        "randomJobKey": "sword,spear,hammer,dagger,bow",
        "templateKey": "randoms/basic",
        "affiliation": "bad",
        "key": "wGt9QheGnNj17e0M4l1iu"
    }
}